import { toastr } from 'react-redux-toastr';
import {
    FETCH_COMPANIES,
    SAVE_COMPANY,
    DELETE_COMPANY,
    UPDATE_ENTITY_FIELD
} from '../types';
import api from '../api';
import countries from '../../consts/Countries.json';
import timezones from '../../consts/Timezones.json';

export const fetchCompanies = (ids) => {
    return {
        type: FETCH_COMPANIES,
        payload: api.company.getAll(ids),
    };
};

export const saveCompany = (company) => {
    if (company.id) {
        return {
            type: SAVE_COMPANY,
            payload: api.company.update(company),
            meta: { companyId: company.id, toastSuccess: true }
        };
    } else {
        return {
            type: SAVE_COMPANY,
            payload: api.company.create(company),
            meta: { toastSuccess: true }
        };
    }
};

export const deleteCompany = (companyId) => {
    return {
        type: DELETE_COMPANY,
        payload: api.company.delete(companyId),
        meta: { companyId, toastSuccess: true }
    };
};

export const fetchCompanyDataFromGoogle = (search, lang = 'he') => {
    return dispatch => {
        api.google.address(search, lang).then(({ data }) => {
            if (data && data.results && data.results.length) {
                const result = data.results[0];

                dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'address', value: result.formatted_address } });
                // dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'deliveryInfo.fullAddress', value: result.formatted_address } });

                // result.address_components.forEach(component => {
                //     if (component.types.includes('locality'))
                //         dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'deliveryInfo.city', value: component.long_name } });
                //     if (component.types.includes('route'))
                //         dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'deliveryInfo.street', value: component.long_name } });
                //     if (component.types.includes('street_number'))
                //         dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'deliveryInfo.streetNumber', value: component.long_name } });
                // });

                if (result.geometry) {
                    const { lat, lng } = result.geometry.location;
                    dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'lat', value: lat } });
                    dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'lng', value: lng } });
                }

                const countryComponent = result.address_components.find(address => address.types && address.types.indexOf('country') >= 0);
                if (countryComponent) {
                    const country_code = countryComponent.short_name;
                    const country = countries.find(c => c.alpha_2 === country_code || c.alpha_3 === country_code);
                    const timezone = timezones.find(t => t.country_code === country_code).timezones[0];
                    
                    // dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'countryCode', value: country_code } });
                    dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'timezone', value: timezone } });
                    dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'currencyCode', value: country.currency_code } });
                }

                // if (result.place_id) {
                //     dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'placeId', value: result.place_id } });
                // }
            } else {
                toastr.error('Error', data.error_message);
            }
        }).catch((err) => { toastr.error('Error', err); });
    };
};
